import React from 'react';

/**
 * Print-safe CO2 formula. The visual subscript uses an ASCII `2` positioned by
 * CSS because EB Garamond maps the Unicode subscript-two glyph to NUL in Linux
 * Chromium PDFs. Keeping both characters as text preserves search and copy.
 */
export function CarbonDioxideFormula(): React.ReactElement {
  return (
    <span data-pdf-chemical-formula="co2" style={{ whiteSpace: 'nowrap' }}>
      CO
      <sub
        data-pdf-safe-subscript="true"
        style={{
          fontSize: '0.72em',
          letterSpacing: 0,
          lineHeight: 0,
          verticalAlign: 'sub',
        }}
      >
        2
      </sub>
    </span>
  );
}
